"use client";
// Libraries
import { useState, useEffect } from "react";
// Functions
// import { getFeatureInfo } from "@/requests";
// import { displayFeaturesOnMap, removeFeaturesFromMap } from "@/mapFunctions";
// Styles
// import { ActiveLayersType, UnknownObjects } from "@/components/map";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowPointer,
  faChevronDown,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import "./FeatureInfo.css";

const host = process.env.REACT_APP_HOST;

/* *********************************************************
                  Global Scope Variables
********************************************************* */

/* *********************************************************
                        Functions
********************************************************* */

// Return the active layers
function queryLayers(activeLayers) {
  console.log(activeLayers, "active ;ayers sto query");
  if (activeLayers.length === 0) return null;
  return activeLayers.join(",");
}

async function getFeatureInfo(params) {
  const url = `${host}/getFeatureInfo`;
  try {
    const response = await axios.get(url, { params });
    const data = response.data;
    console.log(data, "data from getFeatureInfo");
    return data;
  } catch (error) {
    console.log(error);
    try {
      if (error.response.status !== 401) {
        console.error(error);
        return null;
      }
    } catch (error) {
      console.error("API does not response :(");
    }
  }
}
/* *********************************************************
                          Components
********************************************************* */
const FeatureInfo = ({ activeLayers, activeLayersTitles }) => {
  console.log(activeLayers);
  const [showFeatureInfo, setShowFeatureInfo] = useState(false);
  const [queryParams, setQueryParams] = useState({
    service: "WMS",
    version: "1.1.0",
    request: "GetFeatureInfo",
    layers: null,
    query_layers: null,
    info_format: "application/json", // You can choose the format you prefer
    feature_count: 10, // Adjust as needed
    height: null,
    width: null,
    srs: "EPSG:4326",
    bbox: null,
    x: null,
    y: null,
  });
  const [queriedFeatures, setQueriedFeatures] = useState([]);
  if (typeof window !== "undefined" && window.map !== undefined) {
    window.map.on("click", (e) => {
      console.log("clicked");

      const bounds = window.map.getBounds();
      const bboxString = [
        bounds.getWest(), // Minimum longitude
        bounds.getSouth(), // Minimum latitude
        bounds.getEast(), // Maximum longitude
        bounds.getNorth(), // Maximum latitude
      ].join(",");

      const point = window.map.project(e.lngLat);

      setQueryParams({
        ...queryParams,
        layers: queryLayers(activeLayers),
        query_layers: queryLayers(activeLayers),
        height: window.map.getContainer().clientHeight,
        width: window.map.getContainer().clientWidth,
        bbox: bboxString,
        x: Math.round(point.x),
        y: Math.round(point.y),
      });
    });
  }

  // Invoke the request function and sets the response to the corresponding variable
  // when the query params change
  useEffect(() => {
    // Requests and fetches the feature info
    console.log("queryParams", queryParams);
    async function sendRequest(params) {
      if (params.layers === null) return;
      const response = await getFeatureInfo(params);
      console.log(response);
      if (!response) {
        console.error("No valid response.");
        return;
      }

      const validResponse = response.features.map((feature, index) => {
        console.log(feature.id, "feature");
        if (feature.id === "" && params.layers) {
          feature.id = params.layers[index];
        }
        return feature;
      });
      validResponse.length > 0
        ? setShowFeatureInfo(true)
        : setShowFeatureInfo(false);
      setQueriedFeatures(validResponse);
    }
    sendRequest(queryParams);
  }, [queryParams]);

  return (
    showFeatureInfo && (
      <div className="feature-info-tab">
        <div className="feature-info-nav">
          <div className="feature-info-nav-icon">
            <FontAwesomeIcon icon={faArrowPointer} />
          </div>
          <div className="feature-info-nav-title">Feature Info</div>
          <button
            className="feature-info-tab-close-btn"
            onClick={() => setShowFeatureInfo(false)}
          >
            ×
          </button>
        </div>
        <div className="feature-info-tab-wrapper">
          {queriedFeatures.length > 0 && (
            <FeaturesInfoCatalog
              queriedLayers={queryParams.layers}
              queriedFeatures={queriedFeatures}
              activeLayers={activeLayers}
              activeLayersTitles={activeLayersTitles}
            />
          )}
        </div>
      </div>
    )
  );
};

const FeaturesInfoCatalog = ({
  queriedFeatures,
  activeLayers,
  queriedLayers,
  activeLayersTitles,
}) => {
  const layers = [];
  // Return the well formatted title of each layers' Group
  // or undefined in the case of non existing groupId (not actually possible)
  queriedFeatures.forEach((feature, index) => {
    const layer = feature.id.includes(".")
      ? feature.id.split(".")[0]
      : queriedLayers && queriedLayers.includes(",")
      ? queriedLayers.split(",")[index]
      : queriedLayers
      ? queriedLayers
      : "";
    if (!feature.id) return;
    if (!layers.includes(layer)) layers.push(layer);
  });

  console.log(queriedFeatures);
  return (
    <>
      {layers.map((group, index) => (
        <FeaturesInfoGroups
          queriedFeatures={queriedFeatures}
          activeLayers={activeLayers}
          group={group}
          key={index}
          queriedLayers={queriedLayers}
          Title={activeLayersTitles[index]}
        />
      ))}
    </>
  );
};

const FeaturesInfoGroups = ({
  queriedFeatures,
  activeLayers,
  group,
  queriedLayers,
  Title,
}) => {
  const [showFeaturesGroup, setShowFeaturesGroup] = useState(false);
  console.log(group);
  function getGroupTitle(groupId) {
    for (const layer of activeLayers) {
      const layerName = layer.split(":").pop();
      if (layerName === groupId) return layerName;
    }
    return undefined;
  }
  return (
    <div className="feature-info-group">
      <div
        className="feature-info-group-title"
        onClick={() => setShowFeaturesGroup(!showFeaturesGroup)}
      >
        <div className="feature-info-group-title-text">
          {/* {getGroupTitle(group).replace(/_/g, " ")} */}
          {Title.replace("_", "")}
        </div>

        {showFeaturesGroup ? (
          <FontAwesomeIcon icon={faChevronDown} />
        ) : (
          <FontAwesomeIcon icon={faChevronRight} />
        )}
      </div>
      {showFeaturesGroup &&
        queriedFeatures.map((feature, index) => {
          let layerId = "";
          let featureId = "";
          if (feature.id.includes(".")) {
            [layerId, featureId] = feature.id.split(".");
          } else {
            if (queriedLayers)
              featureId =
                queriedLayers && queriedLayers.includes(",")
                  ? queriedLayers.split(",")[index]
                  : queriedLayers
                  ? queriedLayers
                  : "";
            // const title = getGroupTitle(featureId);
            const title = Title;
            if (title) layerId = title;
          }
          if (group === layerId || group === featureId) {
            let subgroup = true;
            if (featureId === group) subgroup = false;
            return (
              <FeaturesInfoContainer
                featureId={featureId}
                featureProps={feature.properties}
                featureGeom={feature.geometry}
                key={index}
                subgroup={subgroup}
              />
            );
          }
        })}
    </div>
  );
};

const FeaturesInfoContainer = ({
  featureId,
  featureProps,
  featureGeom,
  subgroup,
}) => {
  const [showProperties, setShowProperties] = useState(!subgroup);

  // function displayFeature(status) {
  //   if (!featureGeom) return;
  //   if (status) displayFeaturesOnMap(featureId, featureGeom);
  //   if (!status) removeFeaturesFromMap(featureId);
  // }
  return (
    <div
      className="feature-info-feature-container"
      // onMouseEnter={() => displayFeature(true)}
      // onMouseLeave={() => displayFeature(false)}
    >
      {subgroup && (
        <div
          className="feature-info-feature-title"
          onClick={() => setShowProperties(!showProperties)}
        >
          <div className="feature-info-feature-title-text">
            {featureId.replace(/_/g, " ").replace(/-/g, " ")}
          </div>
          {showProperties ? (
            <FontAwesomeIcon icon={faChevronDown} />
          ) : (
            <FontAwesomeIcon icon={faChevronRight} />
          )}
        </div>
      )}
      {showProperties && (
        <div className="feature-info-content">
          <table className="feature-info-props-table">
            <tbody>
              {Object.entries(featureProps).map(([key, value]) => {
                if (key === "GRAY_INDEX") {
                  key = key.replace("GRAY_INDEX", "Value");
                  value = value.toFixed(4);
                }
                return (
                  <tr key={key}>
                    <td>{key}</td>
                    <td>{value}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default FeatureInfo;
